<template>
  <a-form :form="pageForm" class="page-content">
    <div class="form-content">
      <a-form-item
        label="用户名"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 18 }"
      >
        <a-input
          :disabled="formData.id !== undefined"
          v-decorator="[
            'username',
            {
              initialValue: formData.username,
              rules: [{ required: true, message: '请输入管理员登录用户名' }]
            }
          ]"
        />
        <br />
        <span class="ant-form-item-tips"
          >配置管理员登录用户名(需保证唯一，不可重复)</span
        >
      </a-form-item>

      <a-form-item
        v-if="formData.id"
        label="登录密码"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 18 }"
      >
        <a-input
          v-decorator="[
            'password',
            {
              initialValue: formData.password
            }
          ]"
        />
        <br />
        <span class="ant-form-item-tips"
          >配置管理员登录用户名(需保证唯一，不可重复)</span
        >
      </a-form-item>

      <a-form-item
        v-if="!formData.id"
        label="登录密码"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 18 }"
      >
        <a-input
          v-decorator="[
            'password',
            {
              initialValue: formData.password,
              rules: [{ required: true, message: '请输入登录密码' }]
            }
          ]"
        />
        <br />
        <span class="ant-form-item-tips"
          >配置管理员登录用户名(需保证唯一，不可重复)</span
        >
      </a-form-item>

      <!-- <a-form-item
        label="是否主管理"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 18 }"
      >
        <a-switch
          :disabled="formData.id != undefined || is_admin != 1"
          @change="handleIsAdminChange"
          :defaultChecked="formData.is_admin"
          checkedChildren="主管理员"
          unCheckedChildren="普通管理员"
        />
      </a-form-item> -->

      <a-form-item
        label="昵称"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 18 }"
      >
        <a-input
          v-decorator="[
            'nickname',
            {
              initialValue: formData.nickname,
              rules: [{ required: true, message: '请输入管理员昵称' }]
            }
          ]"
        />
        <br />
        <span class="ant-form-item-tips">配置管理员昵称，用于后台显示</span>
      </a-form-item>

      <a-form-item
        label="姓名"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 18 }"
      >
        <a-input
          v-decorator="[
            'real_name',
            {
              initialValue: formData.real_name,
              rules: [{ required: true, message: '请输入管理员姓名' }]
            }
          ]"
        />
        <br />
        <span class="ant-form-item-tips">配置管理员昵称，用于后台显示</span>
      </a-form-item>

      <a-form-item
        label="手机号"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 18 }"
      >
        <a-input
          v-decorator="[
            'phone',
            {
              initialValue: formData.phone,
              rules: [{ required: true, message: '请输入管理员手机号' }]
            }
          ]"
        />
      </a-form-item>
    </div>
    <div class="divider-land"></div>
    <a-form-item style="text-align:center;">
      <a-button
        style="margin-right:20px; width:100px;"
        @click.stop="cancelForm"
      >
        取 消
      </a-button>
      <a-button type="primary" style="width:100px;" @click.stop="submitForm">
        {{ submitBtnLabel }}
      </a-button>
    </a-form-item>
  </a-form>
</template>
<script>
var pageContext;
export default {
  props: {
    submitBtnLabel: {
      type: String,
      default: () => {
        return "新 增";
      }
    },
    platform_type: {
      type: String,
      default: () => {
        return "pl";
      }
    },
    company_id: {
      type: Number,
      default: () => {
        return 0;
      }
    },
    itemData: {
      type: Object,
      default: () => {
        return {};
      }
    },
    layerid: {
      type: String,
      default: ""
    },
    lydata: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  beforeCreate() {
    pageContext = this;
    pageContext.pageForm = pageContext.$form.createForm(pageContext, {
      onValuesChange: function(props, values) {
        let key = Object.keys(values)[0];
        pageContext.formData[key] = values[key];
      }
    });
  },
  data() {
    return {
      is_admin: localStorage.getItem("is_admin"),
      formData: pageContext.initFormData()
    };
  },
  mounted() {
    console.log(pageContext.platform_type);
  },
  methods: {
    initFormData() {
      console.log(pageContext.itemData);
      //编辑管理员
      if (pageContext.itemData.id) {
        return {
          id: pageContext.itemData.id,
          username: pageContext.itemData.username,
          nickname: pageContext.itemData.nickname,
          password: "",
          is_admin: pageContext.itemData.is_admin == 1,
          phone: pageContext.itemData.phone,
          real_name: pageContext.itemData.real_name
        };
      }
      //新增顶级管理员
      else {
        return {
          platform_type: pageContext.platform_type,
          company_id: pageContext.company_id,
          username: pageContext.itemData.username,
          password: "",
          is_admin: false,
          nickname: pageContext.itemData.nickname,
          phone: pageContext.itemData.phone,
          real_name: pageContext.itemData.real_name
        };
      }
    },
    handleIsAdminChange(checked) {
      console.log(checked);
      pageContext.formData.is_admin = checked;
    },
    async submitForm() {
      let result = false;
      pageContext.pageForm.validateFields((errors, values) => {
        result = errors !== null;
      });
      if (result) {
        pageContext.$message.error("请检查表单");
        return;
      }
      pageContext.$http
        .post("/ManagerMg/update", pageContext.formData)
        .then(function(response) {
          if (response.data.status === 1) {
            pageContext.$parent.refreshDataList();
            pageContext.$message.success(response.data.msg);
            pageContext.$layer.close(pageContext.layerid);
          }
        })
        .catch(function(error) {
          pageContext.$message.error("请求异常，请检查1");
          console.log(error);
        });
    },
    cancelForm() {
      pageContext.$layer.close(pageContext.layerid);
      pageContext.$message.info("操作取消！");
    }
  }
};
</script>
<style scoped lang="scss">
.page-content {
  width: 100%;

  .form-content {
    width: 95%;
    margin: 0px auto;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
  }

  .divider-land {
    background-color: #dcdcdc;
    height: 1px;
    width: 80%;
    margin: 10px auto;
  }
}
</style>
